import { render } from "./EstacionBSRN.vue?vue&type=template&id=7760f72d"
import script from "./EstacionBSRN.vue?vue&type=script&lang=js"
export * from "./EstacionBSRN.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__